import { useEffect, useState } from 'react';
import { ValidationErrorCode, getErrorMessageForError } from '../../components/notifications';
import { calculateVat, ICartPricesExtended } from '../../utils';
import { usePrevious } from './usePrevious';
import { INextArticle, mapVehicleConditionForForeignBrand } from 'next-common';
import { isEmpty, isEqual } from 'lodash';
import { VehicleCondition } from 'sales-types-common';

export interface IVatCalculationProps {
  articles: INextArticle[];
  carType?: string;
  vehicleCondition?: VehicleCondition;
  targetedTotalPriceInclVatInclTaxDiscount?: number;
  isUsedCar?: boolean;
  isForeignBrand?: boolean;
}

export interface ICartPricesCustom extends ICartPricesExtended {
  error: boolean;
}

export const useVatStateCalculationHandler = (props: IVatCalculationProps) => {
  const { vehicleCondition = VehicleCondition.NEW, targetedTotalPriceInclVatInclTaxDiscount = null } = props;
  const [finalPrice, setFinalPrice] = useState<ICartPricesCustom>(null);
  const prevArticles = usePrevious(props.articles);
  const isTargetedTotalPriceInclVatInclTaxDiscountChange =
    (props.isUsedCar || props.isForeignBrand) &&
    finalPrice?.salesTotalIncludingVatAndTax !== targetedTotalPriceInclVatInclTaxDiscount;

  useEffect(() => {
    if (!props.articles?.length && finalPrice) {
      setFinalPrice(null);
    }
    if (props.articles?.length && !isEmpty(props?.carType)) {
      if (!isEqual(prevArticles, props.articles) || isTargetedTotalPriceInclVatInclTaxDiscountChange) {
        const mappedVehicleCondition = props.isForeignBrand
          ? mapVehicleConditionForForeignBrand(vehicleCondition)
          : vehicleCondition;
        const vatPrices = calculateVat(
          props.articles,
          props?.carType,
          mappedVehicleCondition,
          targetedTotalPriceInclVatInclTaxDiscount
        );
        if (!vatPrices) {
          console.warn(getErrorMessageForError(ValidationErrorCode.VAT_VALIDATION));
          setFinalPrice({ ...vatPrices, error: true });
        } else {
          setFinalPrice({ ...vatPrices, error: false });
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.articles, targetedTotalPriceInclVatInclTaxDiscount]);

  return { finalPrice };
};
